module.exports = __webpack_public_path__ + "img/visa.26a0c9d9.png";